import React from "react";
import { Field } from "formik";

const Textarea = (props) => {
    return (
        <div className={`${props.error && props.touched ? "input-block input-error" : "input-block"}`}>
            {props.label && <label htmlFor={props.name}>{props.label}</label>}
            <Field
                component={"textarea"}
                name={props.name}
                value={props.value}
                placeholder={props.placeholder}
                disabled={props.disabled}
            />
            {props.error && props.touched && <p className="error-text">{props.error}</p>}
        </div>
    );
};

export default Textarea;
